import React from "react";
import { motion } from "framer-motion";
import { PlusCircle } from "lucide-react";
import "../Styles/Founders.css"; // Import custom CSS file
import { useTranslation } from "react-i18next"; // Import useTranslation hook



const FoundersSection = () => {
    const { t } = useTranslation(); // Initialize translation function

    const founders = t("foundersDetails.reasons", { returnObjects: true });
    return (
        <section className="founders-section">
            <h2 className="founders-heading">{t("foundersDetails.title")}</h2>
            <p
                className="founders-description"
                dangerouslySetInnerHTML={{ __html: t("foundersDetails.topHeading") }}
            ></p>
            <div className="founders-grid">
                {founders.map((founder, index) => (
                    <motion.div
                        key={index}
                        whileHover={{ scale: 1.05 }}
                        className="founder-card"
                    >
                        <div className="founder-image-container">
                            <img src={founder.image} alt={founder.name} className="founder-image" />
                            <button className="founder-button">
                                <PlusCircle className="iconFounder" />
                            </button>
                        </div>
                        <h3 className="founder-name">{founder.name}</h3>
                        <p className="founder-title">{founder.title}</p>
                        <p className="founder-description">{founder.description}</p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default FoundersSection;
